import reducer from './slice';

export default reducer;

export * from './slice';
